import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../../components/ErrorMessage';
import Metadata from '../../../components/Metadata';
import DetailedStatistics from '../../../components/Stats/DetailedStatistics';
import { Page } from '../../../constants/pageTitles';
import useFetch from '../../../helpers/useFetch';

const page = `${Page['recommenders']}`;

const RecommendersStatisticsPage = () => {
  const fetch = useFetch();

  const [recommender, setRecommender] = useState();
  const [error, setError] = useState();
  const { accountId, domainId, id, pageId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages/${pageId}/recommenders/${id}`)
      .then(({ recommender }) => setRecommender(recommender))
      .catch(setError);
  }, [accountId, domainId, pageId, id, fetch]);

  return (
    <>
      <Metadata title={`${page} | ${recommender?.pageId || ''} | ${recommender?.name || 'Unnamed recommender'}`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor
          href={`#/accounts/${accountId}/domains/${domainId}/pages?type=recommenders&page=${recommender?.pageId || ''}`}
        >
          {recommender?.page?.name} Product Blocks
        </Anchor>
        <Text>{recommender?.name || 'Unnamed recommender'}</Text>
      </Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <DetailedStatistics name={recommender?.name} scope="recommenders" id={id} pageId={pageId} />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default RecommendersStatisticsPage;
